import { getCommonConfig } from "../Common/GameConfig";
import { GameCollectableTypeEnum, IGenObstacle } from "./GameModel";

export class GeneratorModel {
    public beforeStaticDistance = getCommonConfig('beforeStatic');
    public lastObstacleDistance = 0;
    public generated: IGenObstacle[] = [];
    public collectables: { type: GameCollectableTypeEnum, distance: number, road: number }[] = [];
    public trackIndex = -1;
    public trackDistance = 0;
    public lastTrackDistane = 0;
    public unicornDistance = 0;
    public obstacleDistance = 100;
    public floraDistance: number = 0;
    public floraDistanceMax: number = 100;
    public signDistance: number = 0;
    public signDistanceNext: number = 30;
    public signDistanceMax: number = 500;
    constructor() {
        this.unicornDistance = this.calcHorseDistance();
    }

    public calcHorseDistance() {
        return Math.random() * 4000 + 4000;
    }

    reset() {
        this.lastObstacleDistance = 0;
        this.generated = [];
        this.collectables = [];
        this.trackIndex = -1;
        this.trackDistance = 0;
        this.lastTrackDistane = 0;
        this.unicornDistance = this.calcHorseDistance();
        this.obstacleDistance = 100;
        this.floraDistance = 0;
        this.signDistance = 0;
        this.signDistanceNext = 30;
    }
}